import {
  cssPropertyToDefaultValueMap,
  generateDefaultStyleProperties,
  generateSkinDefaults,
} from '@wix/editor-elements-panel';
import type { SkinDefinition } from '@wix/editor-elements-panel/src/adapters/types';
import { itemSkinParams } from './skinParams/itemSkinParams';
import { containerSkinParams } from './skinParams/containerSkinParams';
import { regular } from './skinParams/common';
import { scrollButtonSkinParams } from './skinParams/scrollButtonSkinParams';
import { prefixedDropdownSkinParams } from './skinParams/dropdownSkinParams';
import { prefixedDropdownMenuSkinParams } from './skinParams/dropdownMenuSkinParams';
import {
  MenuDisplayMode,
  MenuOrientation,
  MenuOverflow,
  MenuAnimationName,
} from './constants';

export const skinDefinition: Record<string, SkinDefinition> = {
  'wixui.skins.Menu': {
    ...containerSkinParams,
    ...itemSkinParams,
    ...scrollButtonSkinParams,
    ...prefixedDropdownSkinParams,
    ...prefixedDropdownMenuSkinParams,
    'display-mode': {
      type: 'CSSString',
      defaultValue: MenuDisplayMode.Navbar,
      state: regular,
    },
    'spacing-between-label-and-dropdown-icon': {
      type: 'SIZE',
      defaultValue: cssPropertyToDefaultValueMap.gap,
      state: regular,
    },
    'menu-items-main-axis-gap': {
      type: 'SIZE',
      defaultValue: cssPropertyToDefaultValueMap.gap,
      state: regular,
    },
    'menu-items-cross-axis-gap': {
      type: 'SIZE',
      defaultValue: cssPropertyToDefaultValueMap['column-gap'],
      state: regular,
    },
    orientation: {
      type: 'CSSString',
      defaultValue: MenuOrientation.Horizontal,
      state: regular,
    },
    overflow: {
      type: 'CSSString',
      defaultValue: MenuOverflow.Wrap,
      state: regular,
    },
    'divider-display': {
      type: 'CSSString',
      defaultValue: 'none',
      state: regular,
    },
    'container-align': {
      type: 'CSSString',
      defaultValue: cssPropertyToDefaultValueMap['justify-content'],
      state: regular,
    },
    'menu-items-justification': {
      type: 'CSSString',
      defaultValue: 'none',
      state: regular,
    },
    'animation-name': {
      type: 'CSSString',
      defaultValue: MenuAnimationName.None,
      state: regular,
    },
  },
};

export const defaultStyleProperties =
  generateDefaultStyleProperties(skinDefinition);

export default generateSkinDefaults(skinDefinition);
